"use client";
import {memo} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {useTranslation} from "@/shared/i18n";
import {assetPath} from "@/shared/utils/asset-path";

import "./styles/uvp-details.scss";

type UvpTitleKey = "guestService.title" | "professionallyManaged.title" | "transparentPricing.title";
type UvpDescriptionKey = "guestService.description" | "professionallyManaged.description" | "transparentPricing.description";

interface UvpItem {
    icon: string;
    titleKey: UvpTitleKey;
    descriptionKey: UvpDescriptionKey;
}

const UVP_ITEMS: Array<UvpItem> = [
    {
        icon: assetPath("/images/icons/uvp/sparkling.svg"),
        titleKey: "guestService.title",
        descriptionKey: "guestService.description",
    },
    {
        icon: assetPath("/images/icons/uvp/professionally-managed.svg"),
        titleKey: "professionallyManaged.title",
        descriptionKey: "professionallyManaged.description",
    },
    {
        icon: assetPath("/images/icons/uvp/money.svg"),
        titleKey: "transparentPricing.title",
        descriptionKey: "transparentPricing.description",
    },
];

interface UvpDetailsViewProps {
    className?: string;
}

export const UvpDetailsView = memo(function UvpDetailsView({className}: UvpDetailsViewProps) {
    const {t} = useTranslation("rental");

    return (
        <div className={`uvp-details ${className || ""}`}>
            {UVP_ITEMS.map((item) => (
                <div className="uvp-details__item" key={item.icon}>
                    <SmartImage src={item.icon} width={28} height={28} alt="" className="uvp-details__icon" />
                    <div className="uvp-details__content">
                        <p className="uvp-details__title">{t(`uvpDetails.${item.titleKey}`)}</p>
                        <p className="uvp-details__description">{t(`uvpDetails.${item.descriptionKey}`)}</p>
                    </div>
                </div>
            ))}
        </div>
    );
});
